export const formatUnacc = (unacc: boolean | undefined | null): string => {
  if (unacc == null) {
    return "B";
  }
  return unacc ? "Y" : "N";
};
